import React from 'react'
import Headers from '../components/Headers'
import Footer from '../components/Footer'

const AboutUs = () => {
    return (
        <div className='w-full'>
            <Headers />
            <div className='w-[85%] mx-auto py-16'>
                <div className='bg-white dark:bg-gray-900 rounded-lg p-8'>
                    <h1 className='text-3xl font-bold mb-6 text-gray-900 dark:text-white'>About Omah Global</h1>
                    
                    <div className='prose dark:prose-invert max-w-none'>
                        <h2 className='text-xl font-semibold mb-4'>Who We Are</h2>
                        <p className='mb-4 text-gray-700 dark:text-gray-300'>
                            Omah Global is a leading e-commerce platform that connects buyers and sellers in a secure,
                            user-friendly marketplace. We are committed to providing an exceptional online shopping 
                            experience for customers while empowering businesses to grow their online presence.
                        </p>

                        <h2 className='text-xl font-semibold mb-4'>Our Mission</h2>
                        <p className='mb-4 text-gray-700 dark:text-gray-300'>
                            Our mission is to democratize e-commerce by providing accessible tools and platforms 
                            that enable anyone to sell online successfully. We strive to create a trusted marketplace 
                            where quality products meet satisfied customers.
                        </p>

                        <h2 className='text-xl font-semibold mb-4'>What We Offer</h2>
                        <ul className='list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300'>
                            <li>Wide variety of products from verified sellers</li>
                            <li>Secure payment processing with multiple payment options</li>
                            <li>Fast and reliable shipping</li>
                            <li>24/7 customer support</li>
                            <li>Easy returns and refunds</li>
                            <li>Business tools for sellers to manage their stores</li>
                        </ul>

                        <h2 className='text-xl font-semibold mb-4'>Contact Information</h2>
                        <p className='text-gray-700 dark:text-gray-300'>
                            <strong>Email:</strong> support@omaglobal.com<br />
                            <strong>Website:</strong> www.omaglobal.com
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default AboutUs
